import { Splide } from '@splidejs/splide';
// import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener("DOMContentLoaded", () => {

    init_imageScrollBlock();
    init_coverSliderBlock();
    init_peopleSplideBlock(); // Add it to the lifecycle load
 

} );

function init_peopleSplideBlock() {
    const carousels = document.querySelectorAll('.people-carousel');
    if (!carousels.length) return;

    carousels.forEach(carousel => {
        if (carousel.classList.contains('is-initialized')) return; 

        const splide = new Splide(carousel, {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            gap: '30px',
            pagination: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            interval: 3500,
            speed: 700,
            breakpoints: {
                1200: { perPage: 3 },
                992: { perPage: 2 },
                768: { perPage: 1 }
            }
        });

        const bar = carousel.querySelector('.splide-progress-bar');

        const updateProgress = () => {
            if (!bar) return;

            const end = Math.max(splide.length - splide.options.perPage, 1);
            const rate = splide.length <= splide.options.perPage ? 1 : Math.min(splide.index / end, 1);

            bar.style.width = String(100 * rate) + '%';
        };

        splide.on('mounted move updated resized', updateProgress);

        splide.mount();
        carousel.classList.add('is-initialized');
    });
}



function init_imageScrollBlock(){

    let sliders = document.querySelectorAll('.image-scroll-slider--splide');

    if( sliders.length == 0 ) return;

    const args = {
        type   : 'loop',
        pagination: false,
        arrows: false,
        drag   : 'free',
        focus  : 'center',
        perPage: 5,
        gap: '3rem',
        fixedWidth: '110px',
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplay: true,
        speed: 1500,
        interval: 3000
        // autoScroll: {
        //     speed: 0.2
        // },
    }

    Array.from(sliders).forEach( slider => new Splide( slider, args ).mount() )

}

function init_coverSliderBlock(){

    let coverSliders = document.querySelectorAll('.cover-slider');

    if( coverSliders.length == 0 ) return;

    const args = {
        type   : 'fade',
        pagination: true,
        rewind: true,
        arrows: false,
        perPage: 1,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 2500,
        interval: 4000
    }

    Array.from(coverSliders).forEach(slider => {

        // add slide class to covers
        let coverBlocks = slider.querySelectorAll('.wp-block-cover');
        if(coverBlocks.length){
            Array.from(coverBlocks).forEach( cover => cover.classList.add('splide__slide') )
        }

        new Splide( slider, args ).mount();
    })
    
}
